import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const bingDesktopTextRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'bing_text',
  type: 'BingText',
  associationType: 'BingText',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Bing search ad'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showLongHeadline: true,
    showMultipleLineLongHeadline: false,
    showDescription: true,
    showMultipleDescription: false,
    showUrl: true,
    showUrlMultiline: false,
    showAdsLabelInlineWithDescription: true,
    showPreviewTypeString: false,
    showPhoneAndAddressDecorator: true,
  },
  styleOverrides: {
    previewContent: {
      padding: 16,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      minWidth: 280,
    },
    textContainer: {
      maxWidth: '350px',
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '18px',
      maxHeight: '54px',
      marginBottom: '4px',
      overflow: 'hidden',
      overflowWrap: 'break-word',
      textOverflow: 'ellipsis',
      color: '#001BA0',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    description: {
      color: '#333',
      display: 'inline',
      fontSize: '13px',
    },
    descriptionParent: {
      overflow: 'hidden',
      overflowWrap: 'break-word',
      textOverflow: 'ellipsis',
    },
  },
};

export default bingDesktopTextRaw;
